import { alphabeticalCompare, alphabeticalSort } from '@cims-online/shared'
import { CIMSColumn } from '../../../CIMSColumn/types'
import SingleUser from 'components/SingleUser'
import { UseSingleUserColumnOptions } from './types'
import { TableFilterItem } from 'hooks/useTableFilter/types'

/**
 * A custom {@link UseSingleUserColumnOptions.width|width} may be needed to resolve odd spacing
 */
export function useSingleUserColumn<T>({
  title,
  user,
  help,
  width,
  sort,
}: UseSingleUserColumnOptions<T>): CIMSColumn<T> {
  return {
    title: title,
    help,
    width: width ?? 190,
    render: (record) => {
      const renderedUser = user(record)
      if (!renderedUser) return null
      return <SingleUser {...renderedUser} />
    },
    sort: {
      ...sort,
      with: 'callback',
      onCompare: (a, b) => {
        const A = user(a)
        const B = user(b)
        return alphabeticalCompare(
          A?.displayName ?? A?.mail,
          B?.displayName ?? B?.mail
        )
      },
    },
    filter: {
      type: 'default',
      with: 'callback',
      items: (records) =>
        records
          .map((record) => user(record))
          .reduce((items, user) => {
            if (!user) return items
            items.push({
              text: user.displayName ?? user.mail,
              value: user.mail,
              tooltip: user.displayName ? user.mail : undefined,
            })
            return items
          }, Array<TableFilterItem>())
          .sort(alphabeticalSort('text')),
      onFilter: (value, record) => user(record)?.mail === value,
    },
  }
}
